import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { _FixedAssetOrderConcept } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectDepreciationUnits } from "../FixedAssetLine/SelectDepreciationUnits";
import { SelectAccountantTree } from "../../../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";



export const FixedAssetOrderConcept = () => {

    const fixedassets = useDataBean(_FixedAssetOrderConcept);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        fixedassets.instance.getFixedAssetOrderConceptCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        fixedassets.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        fixedassets.deleteItemVoid(fixedassets.bean.IDFixedAssetOrderConcept).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        fixedassets.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDFixedAssetOrderConcept', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Cuenta Contable (D)', property: 'DebtAccountantIDStrName', visible: true },
        { title: 'Cuenta Contable (C)', property: 'CreditAccountantIDStrName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${fixedassets.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Conceptos de Cuentas de Orden">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={fixedassets.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={fixedassets.bean.Name} onChange={fixedassets.handleChange} />

                            </div>
                            <div className="col-md-6">

                                <SelectAccountantTree label="Cuenta Contable (D)" jsonCode={fixedassets.bean.DebtAccountantIDStr} onChange={(e) => { fixedassets.setBean({ ...fixedassets.bean, "DebtAccountantIDStr": e.JsonCode }) }} />
                                {/* <label>Cuenta Contable (D)</label>
                                <input type="text" name="DebtAccountantID" className="form-control" value={fixedassets.bean.DebtAccountantID} onChange={fixedassets.handleChange} /> */}
                            </div>
                            <div className="col-md-6">
                                <SelectAccountantTree label="Cuenta Contable (C)" jsonCode={fixedassets.bean.CreditAccountantIDStr} onChange={(e) => { fixedassets.setBean({ ...fixedassets.bean, "CreditAccountantIDStr": e.JsonCode }) }} />
                                {/* <label>Cuenta Contable (C)</label>
                                <input type="text" name="CreditAccountantID" className="form-control" value={fixedassets.bean.CreditAccountantID} onChange={fixedassets.handleChange} /> */}
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={fixedassets.bean.Description} onChange={fixedassets.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {fixedassets.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}